import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import {
  CreateVirtualAccountParams,
  DeleteVirtualAccountByIdResponse,
  GetVirtualAccountByIdResponse,
  GetVirtualAccountRequestParams,
  GetVirtualAccountResponse,
  UpdateVirtualAccountRequestParams,
} from '../../pages/virtualAccounts/virtualAccounts.interface';
import { environment } from '../../../environments/environment';
import { toQueryString } from '../../shared/helpers/helpers';

@Injectable({
  providedIn: 'root',
})
export class VirtualAccountsService {
  private apiUrl = environment.api + '/virtual-accounts';

  constructor(private http: HttpClient) {}

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getVirtualAccountService(requestParams: GetVirtualAccountRequestParams): Observable<GetVirtualAccountResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetVirtualAccountResponse>(url).pipe(
      tap((response) => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError((error) => this.handleError(error)) // ✅ Pakai arrow function
    );
  }

  getVirtualAccountById(id: string): Observable<GetVirtualAccountByIdResponse> {
    return this.http.get<GetVirtualAccountByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  deleteVirtualAccountById(id: string): Observable<DeleteVirtualAccountByIdResponse> {
    return this.http.delete<DeleteVirtualAccountByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  createVirtualAccount(virtualAccountData: CreateVirtualAccountParams): Observable<GetVirtualAccountByIdResponse> {
    return this.http.post<GetVirtualAccountByIdResponse>(this.apiUrl, virtualAccountData).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  updateVirtualAccount(id: string, virtualAccountData: UpdateVirtualAccountRequestParams): Observable<GetVirtualAccountByIdResponse> {
    return this.http.put<GetVirtualAccountByIdResponse>(`${this.apiUrl}/${id}`, virtualAccountData).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }
}
